import { CheckBoxItem } from "../components/checkBox/CheckBoxGroup";
import { ConstMessage } from "../config/const";
import { Groups } from "../model/Groups";
import yup, { validNumber, validNumber1orMore } from "../utility/ValidationUtilty";
import { convertDateToString } from "../utility/ConvertUtily";

export type PointCategory = {
  categoryId: number,
  categoryName: string,
  sortKey: number,
};

export type PointType = {
  categoryId: number,
  sortKey: number,
  typeId: string,
  typeName: string,
};
 
 export type PointHistoryData = {
  id: string,
  tenantId: string,
  userId: string,
  displayUserId: string,
  userName: string,
  tranType: string,
  ptSettingId?: string,
  ptCategoryId?: number,
  ptCategoryName?: string,
  ptTypeId?: string,
  ptTypeName?: string,
  ptName?: string,
  grantPoints: number,
  heldPoints?: number,
  isBonus: boolean,
  occurrenceDate: Date,
  grantFlg?: boolean,
  grantDate?: Date,
  expirationDate?: Date,
  note?: string,
  eventMsgId?: string,
  createAt: Date,
  updateAt: Date,
  expirationFlg: boolean,
}

// ポイント履歴の初期値
export const newPointHistory = (): PointHistoryData => {
  return {
    id: "",
    tenantId: "",
    userId: "",
    displayUserId: "",
    userName: "",
    tranType: "",
    ptSettingId: "",
    ptCategoryId: 0,
    ptCategoryName: "",
    ptTypeId: "",
    ptTypeName: "",
    ptName: "",
    grantPoints: 0,
    heldPoints: 0,
    isBonus: false,
    occurrenceDate: now,
    grantFlg: false,
    grantDate: now,
    expirationDate: now,
    note: "",
    eventMsgId: "",
    createAt: now,
    updateAt: now,
    expirationFlg: false,
  };
};

export const pointDataTimestampToDate = (data: any | undefined): PointHistoryData => {
  if(data.occurrenceDate !== null){
    // ミリ秒まで取得
    const occurrenceDate = new Date(
      data.occurrenceDate.seconds * 1000 + data.occurrenceDate.nanoseconds / 1e6
    );
    data.occurrenceDate = occurrenceDate;
  }
  if(data.grantDate && data.grantDate !== null){
    const grantDate = new Date(data.grantDate.seconds * 1000);
    data.grantDate = new Date(grantDate.getFullYear(), grantDate.getMonth(), grantDate.getDate(), grantDate.getHours(), grantDate.getMinutes(), grantDate.getSeconds());
  }
  if(data.expirationDate && data.expirationDate !== null){
    const expirationDate = new Date(data.expirationDate.seconds * 1000);
    data.expirationDate = new Date(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate());
  }
  if(data.createAt !== null){
    const createAt = new Date(data.createAt.seconds * 1000);
    data.createAt = new Date(createAt.getFullYear(), createAt.getMonth(), createAt.getDate(), createAt.getHours(), createAt.getMinutes(), createAt.getSeconds());
  }
  if(data.updateAt !== null){
    const updateAt = new Date(data.updateAt.seconds * 1000);
    data.updateAt = new Date(updateAt.getFullYear(), updateAt.getMonth(), updateAt.getDate(), updateAt.getHours(), updateAt.getMinutes(), updateAt.getSeconds());
  }
  return data;
};

// ポイント履歴一覧検索用
export type SearchPoint = {
  id: string,
  displayUserId: string,
  userName: string,
  tranType: CheckBoxItem[];
  ptCategoryId?: number,
  ptCategoryName?: string,
  ptTypeId: string,
  ptTypeName: string,
  ptName: string,
  expirationDateStart: string,
  expirationDateEnd: string,
  occurrenceDateStart: string,
  occurrenceDateEnd: string,
  topic: Groups[];
}

// ポイント履歴一覧検索初期値
export const PointListSearchDefault = (): SearchPoint => {
  return {
    id: "",
    displayUserId: "",
    userName: "",
    tranType: [],
    ptCategoryId: undefined,
    ptCategoryName: "",
    ptTypeId: "",
    ptTypeName: "",
    ptName: "",
    expirationDateStart: "",
    expirationDateEnd: "",
    occurrenceDateStart: "",
    occurrenceDateEnd: "",
    topic: [],
  }
}

export type PointAdjustHistory = {
  id: string,
  tenantId: string,
  ptCategoryId: number,
  ptCategoryName: string,
  ptTypeId: string,
  ptTypeName: string,
  ptName: string,
  grantPoints: number | undefined,
  occurrenceDate: Date,
  note: string,
  createUser: string,
  createAt: Date,
  updateAt: Date,
  expirationDate?: Date;
};

const now = new Date();

// ポイント調整履歴の初期値
export const newPointAdjustHistory = (): PointAdjustHistory => {
  return {
    id: "",
    tenantId: "",
    ptCategoryId: 0,
    ptCategoryName: "",
    ptTypeId: "",
    ptTypeName: "",
    ptName: "",
    grantPoints: undefined,
    occurrenceDate: now,
    note: "",
    createUser: "",
    createAt: now,
    updateAt: now,
  };
};

export type AdjustUsers = {
  id: string,
  tenantId: string;
  pointAdjustHistoryId: string;
  userId: string;
  displayUserId: string;
  userName: string;
  groupNameArr?: string[];
  executionResult: boolean;
  errorDetail?: string;
};

// ポイント調整データのマッピング
export const PointAdjustHistoryTimestampToDate = (data: any | undefined): PointAdjustHistory => {
  if(data?.occurrenceDate.seconds){
    data.occurrenceDate = new Date(data?.occurrenceDate.seconds * 1000);
  }
  if(data?.createAt.seconds){
    data.createAt = new Date(data?.createAt.seconds * 1000);
  }
  if(data?.updateAt.seconds){
    data.updateAt = new Date(data?.updateAt.seconds * 1000);
  }
  return data;
};


// ポイント調整データのバリデーション
export const pointAdjustSchema = yup.object({
  ptCategoryId: yup.string().label('').required(),
  ptTypeId: yup.string().label('').required().test((value, testContext) => {
    if(testContext.parent.ptTypeFlg){
      return testContext.createError({
        message: ConstMessage.ERR_NOT_ADD_POINT_SETTINGS
      })
    }
    return true;
  }),
  ptName: yup.string().label('').required(),
  occurrenceDate: yup.string().label('').required().test((value, testContext) => {
    const occurrenceDate = new Date(testContext.parent.occurrenceDate);
    const occurrenceDateResult = new Date(
      occurrenceDate.getFullYear(),
      occurrenceDate.getMonth(),
      occurrenceDate.getDate()
    )
    const now = new Date();
    const nowDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    )
    if(occurrenceDateResult < nowDate){
      return testContext.createError({
        message: `${convertDateToString(new Date(nowDate.setDate(nowDate.getDate() - 1)))}より後でなければなりません。`
      })
    }
    return true;
  }),
  // ポイント数
  grantPoints: yup.string().test((value, testContext) => {
    let result = validNumber(value, testContext, true);
    if (result === true && Number(value) === 0) {
      // 0
      result = testContext.createError({ message: ConstMessage.ERR_GRANTPOINTS_NUMBER });
    }
    return result;
  }),
});

// 有効期限の取得
export const getExpirationDate =(categorySettings: PtCategorySettings, date?: Date) => {
  const baseDate = date ? date : new Date();
  const formatDate =new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  const m = formatDate.getMonth() + 1;
  if(categorySettings && categorySettings.expireFlg && categorySettings.dateOfExpiryMap){
    const dateOfExpiry = categorySettings.dateOfExpiryMap;
    if(dateOfExpiry.expirationUnit === "year"){
      const val = dateOfExpiry.expirationValue ?? 0;
      const yearPlusDate = new Date(formatDate.setFullYear(formatDate.getFullYear() + val));
      const month = yearPlusDate.getMonth() + 1;
      const day = yearPlusDate.getDate();
      if(m !== month){
        return new Date(yearPlusDate.setDate(yearPlusDate.getDate() - day));
      }
      return new Date(yearPlusDate.setDate(yearPlusDate.getDate() - 1));
    }else if(dateOfExpiry.expirationUnit === "month"){
      const val = dateOfExpiry.expirationValue ?? 0;
      const monthPlusDate = new Date(formatDate.setMonth(formatDate.getMonth() + val));
      const month = monthPlusDate.getMonth() + 1;
      const day = monthPlusDate.getDate();
      const resultVal = m + val > 12 ? m + val - 12 : m + val;
      if(resultVal !== month){
        return new Date(monthPlusDate.setDate(monthPlusDate.getDate() - day));
      }
      return new Date(monthPlusDate.setDate(monthPlusDate.getDate() - 1));
    }else if(dateOfExpiry.expirationUnit === "limitMonth" && dateOfExpiry.expirationYm){
      let expirationYm = dateOfExpiry.expirationYm;
      expirationYm.setMonth(expirationYm.getMonth()+1, 0);
      return expirationYm;
    }
    return;
  }else{
    return;
  }
}

// ポイントカテゴリ設定
export type PtCategorySettings = {
  id: string,
  tenantId: string,
  categoryId: number,
  categoryName: string,
  limitPointFlg: boolean,
  numberOfGrantsMap?: NumberOfGrantsMap,
  expireFlg: boolean,
  dateOfExpiryMap?: DateOfExpiryMap,
  createAt: Date,
  updateAt: Date,
}

// 合計上限設定
export type NumberOfGrantsMap = {
  unit?: string,
  baseMonth?: number,
  limitPoint?: number,
}
// 有効期限設定
export type DateOfExpiryMap = {
  expirationUnit?: string,
  expirationValue?: number,
  expirationYm?: Date,
}

// ポイント付与設定
export type PtAwardedSettings = {
  id : string, // ドキュメントID
  tenantId : string, // テナントID
  categoryId : number, // カテゴリID
  categoryName : string, // カテゴリ名
  typeId : string, // タイプID
  typeName : string, // タイプ名
  name : string, // ポイント名
  basePoint? : number, // ポイント数
  pointSubject? : number, // ポイント種別
  registWtPoint? : number, // ポイント数（体重登録）
  registBpPoint? : number, // ポイント数（血圧登録）
  registSamePoint? : number, // ポイント数（同時登録）
  activityTime? : number, // 活動時間
  pointKind : number, // ポイント種別
  target? : number, // 付与対象
  status : number, // ステータス
  validPeriodDateFrom? : Date, // 有効期間（開始）
  validPeriodDateTo? : Date, // 有効期間（終了）
  steps? : number, // 歩数
  rangeStepsLower? : number, // 歩数（下限）
  rangeStepsUpper? : number, // 歩数（上限）
  rangeStepsMap? : RangeStepsMap[],
  rangeStepsUnit? : string, // 歩数範囲単位
  rangeStepsPeriodDateFrom? : Date, // 歩数範囲開始年月日
  rangeStepsPeriodDateTo? : Date, // 歩数範囲終了年月日
  numberLimitFlg : boolean, // 付与回数制限設定有無
  numberLimitMap? : NumberLimitMap, // 付与回数制限設定
  pointLimitFlg : boolean, // ポイント数合計上限設定有無
  pointLimitMap? : PointLimitMap, // ポイント数合計上限設定
  bonusSettingFlg : boolean, // ボーナス設定
  createUser : string, // 作成者
  createAt : Date, // 登録日時
  updateAt : Date, // 更新日時

  // Form用文字列型
  _strBasePoint? : string,        // ポイント数
  _strRegistWtPoint? : string,    // ポイント数（体重登録）
  _strRegistBpPoint? : string,    // ポイント数（血圧登録）
  _strRegistSamePoint? : string,  // ポイント数（同時登録）
  _strActivityTime? : string,     // 活動時間
  _strSteps? : string;            // 歩数
  _strRangeStepsLower? : string,  // 歩数（下限）
  _strRangeStepsUpper? : string,  // 歩数（上限）
}
// ポイント付与設定のマッピング
export const ptAwardedSettingsTimestampToDate = (data: any | undefined): PtAwardedSettings => {
  // 有効期間（開始）
  if(data?.validPeriodDateFrom && data?.validPeriodDateFrom.seconds){
    data.validPeriodDateFrom = new Date(data?.validPeriodDateFrom.seconds * 1000);
  }
  // 有効期間（終了）
  if(data?.validPeriodDateTo && data?.validPeriodDateTo.seconds){
    data.validPeriodDateTo = new Date(data?.validPeriodDateTo.seconds * 1000);
  }
  // 歩数範囲開始年月日
  if(data?.rangeStepsPeriodDateFrom && data?.rangeStepsPeriodDateFrom.seconds){
    data.rangeStepsPeriodDateFrom = new Date(data?.rangeStepsPeriodDateFrom.seconds * 1000);
  }
  // 歩数範囲終了年月日
  if(data?.rangeStepsPeriodDateTo && data?.rangeStepsPeriodDateTo.seconds){
    data.rangeStepsPeriodDateTo = new Date(data?.rangeStepsPeriodDateTo.seconds * 1000);
  }
  // 付与回数制限設定
  if (data?.numberLimitMap) {
    // 期間開始年月日
    if(data?.numberLimitMap.dateFrom && data?.numberLimitMap.dateFrom.seconds){
      data.numberLimitMap.dateFrom = new Date(data?.numberLimitMap.dateFrom.seconds * 1000);
    }
    // 期間終了年月日
    if(data?.numberLimitMap.dateTo && data?.numberLimitMap.dateTo.seconds){
      data.numberLimitMap.dateTo = new Date(data?.numberLimitMap.dateTo.seconds * 1000);
    }
  }
  // ポイント数合計上限設定
  if (data?.pointLimitMap) {
    // 期間開始年月日
    if(data?.pointLimitMap.dateFrom && data?.pointLimitMap.dateFrom.seconds){
      data.pointLimitMap.dateFrom = new Date(data?.pointLimitMap.dateFrom.seconds * 1000);
    }
    // 期間終了年月日
    if(data?.pointLimitMap.dateTo && data?.pointLimitMap.dateTo.seconds){
      data.pointLimitMap.dateTo = new Date(data?.pointLimitMap.dateTo.seconds * 1000);
    }
  }
  if(data?.createAt.seconds){
    data.createAt = new Date(data?.createAt.seconds * 1000);
  }
  // 更新日時
  if(data?.updateAt.seconds){
    data.updateAt = new Date(data?.updateAt.seconds * 1000);
  }
  return data;
};
// 付与回数制限設定
export type NumberLimitMap = {
  numberLimit? : number, // 制限回数
  period? : string, // 期間指定
  dateFrom? : Date, // 期間開始年月日
  dateTo? : Date, // 期間終了年月日

  // Form用文字列型
  _strNumberLimit? : string, // 制限回数
}
// ポイント数合計上限設定
export type PointLimitMap = {
  pointLimit? : number, // 上限ポイント
  period? : string, // 期間指定
  dateFrom? : Date, // 期間開始年月日
  dateTo? : Date, // 期間終了年月日

  // Form用文字列型
  _strPointLimit? : string, // 上限ポイント
}
//歩数範囲設定
export type RangeStepsMap = {
  id: number|string;
  rangeStepsLower?: number;
  rangeStepsUpper?: number;
  basePoint?: number

  // Form用文字列型
  _strBasePoint?: string; // ポイント数
  _strRangeStepsLower?: string; // 歩数（下限）
  _strRangeStepsUpper?: string; // 歩数（上限）
}
export const RangeStepsMap = (): RangeStepsMap[] => {
  return[
    {
      id: "",
      rangeStepsLower: undefined,
      rangeStepsUpper: undefined,
      basePoint: undefined,
    }
  ]
};

// ボーナスポイント設定
export type PtBonusSettings = {
  id : string , // ドキュメントID
  ptAwardedId : string , // 付与設定ID
  tenantId : string , // テナントID
  categoryId : number , // カテゴリID
  categoryName : string , // カテゴリ名
  typeId : string , // タイプID
  typeName : string , // タイプ名
  status : number, // ステータス
  validPeriodDateFrom? : Date, // 有効期間（開始）
  validPeriodDateTo? : Date, // 有効期間（終了）
  name : string , // ポイント名
  bonusId : string, // ボーナスID
  no : number , // No
  condition : string , // 条件
  numOfDays? : number , // 日数
  dateFrom? : Date , // 開始年月日
  dateTo? : Date , // 終了年月日
  numOfTimes? : number , // 回数
  bonusPoints? : number , // ポイント数

  // Form用文字列型
  _strNumOfDays?: string,     // 日数
  _strNumOfTimes?: string,    // 回数
  _strBonusPoints? : string,  // ポイント数
}
// ボーナスポイント設定のマッピング
export const ptBonusSettingsTimestampToDate = (data: any | undefined): PtBonusSettings => {
  // ステータス 有効期間（開始）
  if(data?.validPeriodDateFrom && data.validPeriodDateFrom.seconds){
    data.validPeriodDateFrom = new Date(data?.validPeriodDateFrom.seconds * 1000);
  }
  // ステータス 有効期間（終了）
  if(data?.validPeriodDateTo && data.validPeriodDateTo.seconds){
    data.validPeriodDateTo = new Date(data?.validPeriodDateTo.seconds * 1000);
  }
  // 開始年月日
  if(data?.dateFrom && data?.dateFrom.seconds){
    data.dateFrom = new Date(data?.dateFrom.seconds * 1000);
  }
  // 終了年月日
  if(data?.dateTo && data?.dateTo.seconds){
    data.dateTo = new Date(data?.dateTo.seconds * 1000);
  }
  return data;
};

export const newPtAwardedSettings = ():  PtAwardedSettings => {
  return {
    id : "",
    tenantId : "",
    categoryId : 0,
    categoryName : "",
    typeId : "",
    typeName : "",
    name : "",
    basePoint : 0,
    pointSubject :0,
    registWtPoint : 0,
    registBpPoint : 0,
    registSamePoint : 0,
    activityTime : 0,
    pointKind : 0,
    target : 0,
    status : 0,
    validPeriodDateFrom : new Date(),
    validPeriodDateTo : new Date(),
    steps : 0,
    rangeStepsLower : 0,
    rangeStepsUpper : 0,
    rangeStepsMap : undefined,
    rangeStepsUnit : "",
    rangeStepsPeriodDateFrom : new Date(),
    rangeStepsPeriodDateTo : new Date(),
    numberLimitFlg : false,
    numberLimitMap : undefined,
    pointLimitFlg : false,
    pointLimitMap : undefined,
    bonusSettingFlg : false,
    createUser : "",
    createAt : new Date(),
    updateAt : new Date(),
  };
};

export const newPtCategorySettings: PtCategorySettings = {
  id: "",
  tenantId: "",
  categoryId: 0,
  categoryName: "",
  limitPointFlg: false,
  numberOfGrantsMap: undefined,
  expireFlg: false,
  dateOfExpiryMap: undefined,
  createAt: new Date(),
  updateAt: new Date(),
}

export const pointCategorySchema = (limitPointFlg: boolean, expireFlg: boolean) => yup.object({
  numberOfGrantsMap: yup.object().shape({
    unit: yup.string().test((value, testContext) => {
      const unit = testContext.parent.unit;
      if (limitPointFlg === true) {
        if (unit === '') {
          return testContext.createError({
            message: ConstMessage.ERR_NOT_INPUT
          });
        } else if (['none', 'year', 'month'].includes(unit) === false) {
          return testContext.createError({
            message: ConstMessage.ERR_INVALID_VALUE
          });
        }
      }
      return true;
    }),
    baseMonth: yup.number().test((value, testContext) => {
      const baseMonth = testContext.parent.baseMonth;
      const unit = testContext.parent.unit;
      if (limitPointFlg === true && unit === 'year') {
        if (baseMonth === null || baseMonth === undefined || baseMonth === 0) {
          return testContext.createError({
            message: ConstMessage.ERR_NOT_INPUT
          });
        } else if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].includes(baseMonth) === false) {
          return testContext.createError({
            message: ConstMessage.ERR_INVALID_VALUE
          });
        }
      }
      return true;
    }),

    // ポイント上限
    limitPoint: yup.string().test((value, testContext) => {
      if (limitPointFlg === true) {
        const limitPoint = testContext.parent.limitPoint;
        return validNumber1orMore(limitPoint, testContext, true);
      }
      return true;
    }),
  }),
  dateOfExpiryMap: yup.object().shape({
    expirationUnit: yup.string().test((value, testContext) => {
      const expirationUnit = testContext.parent.expirationUnit;
      if (expireFlg === true) {
        if (expirationUnit === '') {
          return testContext.createError({
            message: ConstMessage.ERR_NOT_INPUT
          });
        } else if (['year', 'month', 'limitMonth'].includes(expirationUnit) === false) {
          return testContext.createError({
            message: ConstMessage.ERR_INVALID_VALUE
          });
        }
      }
      return true;
    }),

    // 設定値
    expirationValue: yup.string().test((value, testContext) => {
      if (expireFlg === true) {
        const expirationValue = testContext.parent.expirationValue;
        const expirationUnit = testContext.parent.expirationUnit;
  
        if (expirationUnit === 'year') {
          // 指定方法：期間（年）
          return validNumber1orMore(expirationValue, testContext, true);
        } else if (expirationUnit === 'month') {
          // 指定方法：期間（月）
          if (expirationValue === null || expirationValue === undefined || expirationValue === 0) {
            return testContext.createError({
              message: ConstMessage.ERR_NOT_INPUT
            });
          }
        }
      }
      return true;
    }),
  }),
  expirationYmString: yup.string().test((value, testContext) => {
    const expirationYm = testContext.parent.expirationYmString;
    const expirationUnit = testContext.parent.dateOfExpiryMap?.expirationUnit;
    if (!expireFlg || expirationUnit !== 'limitMonth') {
      return true;
    }
    const nowDate = new Date();
    const dateExpirationYm = new Date(expirationYm);
    if (expireFlg === true && expirationUnit === 'limitMonth') {
      if (expirationYm === 'Invalid Date' || expirationYm === '') {
        return testContext.createError({
          message: ConstMessage.ERR_NOT_INPUT
        });
      } else if (Number.isNaN(new Date(expirationYm).getTime())) {
        return testContext.createError({
          message: ConstMessage.ERR_BIRTH_DATE_INVALID_FORMAT
        });
      } else if (nowDate >= dateExpirationYm) {
        const nextMonth = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1)
        const strYear = nextMonth.getFullYear();
        const strMonth = ("00" + (nextMonth.getMonth() + 1)).slice(-2);
        return testContext.createError({
          message: ConstMessage.ERR_IMPUT_DATE_THAN_AFTER.replace('%1', (`${strYear}/${strMonth}`))
        });
      }
    }
    return true;
  }),
});